<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--PWA 종합현황-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001287') }}</span>
				</div>
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--승인-->
							<th class="col-1">{{ getMessage_('QWCC001001') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaApprCnt, 'A')">{{ claimInfo.pwaApprCnt }}</td>

							<!--기각-->
							<th class="col-1">{{ getMessage_('QWCC001002') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaRjctCnt, 'G')">{{ claimInfo.pwaRjctCnt }}</td>

							<!--반려-->
							<th class="col-1">{{ getMessage_('QWCC001003') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaGvbkCnt, 'R')">{{ claimInfo.pwaGvbkCnt }}</td>

							<!--미결-->
							<th class="col-1">{{ getMessage_('QWCC001277') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaPndgCnt, 'O')">{{ claimInfo.pwaPndgCnt }}</td>

							<!--작성중-->
							<!-- <th class="col-1">{{ getMessage_('QWCC002022') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaWrtCnt, 'W')">{{ claimInfo.pwaWrtCnt }}</td> -->
						</tr>

						<tr>
							<!--처리완료-->
							<th class="col-1">{{ getMessage_('QWCC001278') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaCmptCnt, 'C')">{{ claimInfo.pwaCmptCnt }}</td>

							<!--장기미결(3일이상)-->
							<th class="col-1">{{ getMessage_('QWCC001279') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaLtmCnt, 'LO')">{{ claimInfo.pwaLtmCnt }}</td>

							<!--처리율-->
							<th class="col-1">{{ getMessage_('QWCC001281') }}</th>
							<td class="col-1">{{ claimInfo.pwaPrcRt }}</td>

							<!--전체-->
							<th class="col-1">{{ getMessage_('QWCC001282') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaTotCnt, '')">{{ claimInfo.pwaTotCnt }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--클레임 종합현황-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001288') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--승인-->
							<th class="col-1">{{ getMessage_('QWCC001001') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoClaimClick(claimInfo.clmApprCnt, 'A')">{{ claimInfo.clmApprCnt }}</td>

							<!--기각-->
							<!-- <th class="col-1"></th>
							<td class="col-1"></td> -->
							<th class="col-1">{{ getMessage_('QWCC001002') }}</th>
							<!--RO신청현항-->
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmRjctCnt, 'G')">{{ claimInfo.clmRjctCnt }}</td>

							<!--반려-->
							<th class="col-1">{{ getMessage_('QWCC001003') }}</th>
							<!--RO신청현황-->
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmGvbkCnt, 'R')">{{ claimInfo.clmGvbkCnt }}</td>

							<!--미결-->
							<th class="col-1">{{ getMessage_('QWCC001277') }}</th>
							<!--RO신청형황-->
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmPndgCnt, 'O')">{{ claimInfo.clmPndgCnt }}</td>

							<!--작성중-->
							<!-- <th class="col-1">{{ getMessage_('QWCC002022') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmWrtCnt, 'W')">{{ claimInfo.clmWrtCnt }}</td> -->
						</tr>

						<tr>
							<!--처리완료-->
							<th class="col-1">{{ getMessage_('QWCC001278') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmCmptCnt, 'C')">{{ claimInfo.clmCmptCnt }}</td>

							<!--장기미결(7일이상)-->
							<th class="col-1">{{ getMessage_('QWCC001280') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmLtmCnt, 'LO')">{{ claimInfo.clmLtmCnt }}</td>

							<!--처리율-->
							<th class="col-1">{{ getMessage_('QWCC001281') }}</th>
							<td class="col-1" style="cursor: pointer">{{ claimInfo.clmPrcRt }}</td>

							<!--전체-->
							<th class="col-1">{{ getMessage_('QWCC001282') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmTotCnt, '')">{{ claimInfo.clmTotCnt }}</td>
						</tr>
					</tbody>
				</table>
			</div><div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--클레임 종합현황-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC002093') }}</span>
				</div>
			</div>

			
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
						<!--승인-->
						<th class="col-1">{{ getMessage_('QWCC002094') }}</th>
						<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.rptpNapprCnt, 'NA')">{{ claimInfo.rptpNapprCnt }}</td>

						<!--기각-->
						<!-- <th class="col-1"></th>
						<td class="col-1"></td> -->
						<th class="col-1">{{ getMessage_('QWCC002095') }}</th>
						<!--已申请-->
						<td class="col-1" style="cursor: pointer" @click="onGoRtnPartMstClick(claimInfo.rptpApprCnt, 'A')">{{ claimInfo.rptpApprCnt }}</td>

						<!--반려-->
						<th class="col-1">{{ getMessage_('QWCC002096') }}</th>
						<!--待回收-->
						<td class="col-1" style="cursor: pointer" @click="onGoRtnPartMstClick(claimInfo.rptpRecyCnt, 'R')">{{ claimInfo.rptpRecyCnt }}</td>

						<!--미결-->
						<th class="col-1">{{ getMessage_('QWCC002097') }}</th>
						<!--已回收-->
						<td class="col-1" style="cursor: pointer" @click="onGoRtnPartMstClick(claimInfo.rptpFinishCnt, 'O')">{{ claimInfo.rptpFinishCnt }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--PWA 처리대기 현황-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001289') }}</span>
				</div>
			</div>
			<div style="width: 450px">
				<div class="sf-table">
					<table class="qms-table" style="cursor: pointer">
						<tbody>
							<tr>
								<th class="col-1">{{ getMessage_('QWCC001984') }}</th>
								<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaLtm30Cnt, '1ML')">
									{{ claimInfo.pwaLtm30Cnt }}
								</td>
							</tr>
							<tr>
								<th class="col-1">{{ getMessage_('QWCC001985') }}</th>
								<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaLtm90Cnt, '3ML')">
									{{ claimInfo.pwaLtm90Cnt }}
								</td>
							</tr>
							<tr>
								<th class="col-1">{{ getMessage_('QWCC001986') }}</th>
								<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(claimInfo.pwaLtmOverCnt, '3MG')">
									{{ claimInfo.pwaLtmOverCnt }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--클레임 처리대기 현황-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001290') }}</span>
				</div>
			</div>
			<div style="width: 450px">
				<div class="sf-table">
					<table class="qms-table" style="cursor: pointer">
						<tbody>
							<tr>
								<th class="col-1">{{ getMessage_('QWCC001984') }}</th>
								<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmLtm30Cnt, '1ML')">
									{{ claimInfo.clmLtm30Cnt }}
								</td>
							</tr>
							<tr>
								<th class="col-1">{{ getMessage_('QWCC001985') }}</th>
								<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmLtm90Cnt, '3ML')">
									{{ claimInfo.clmLtm90Cnt }}
								</td>
							</tr>
							<tr>
								<th class="col-1">{{ getMessage_('QWCC001986') }}</th>
								<td class="col-1" style="cursor: pointer" @click="onGoRoClick(claimInfo.clmLtmOverCnt, '3MG')">
									{{ claimInfo.clmLtmOverCnt }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
//탭메뉴로 보낼 VUE파일을 임포트한다. 나중에 임포트된 파일을 탭으로 열때 파라미터로 컴포넌트를 넘겨야됨
import PwaApcn from '@mqy/ceqi/PwaApcn/PwaApcn.vue';
import ClamMst from '@mqy/qlty/ClamMst/ClamMst.vue';
import ClamRepay from '@mqy/qlty/ClamRepay/ClamRepay.vue';
import RoApcn from '@mqy/ceqi/RoApcn/RoApcn.vue';
import RtnPartMst from '@mqy/ceqi/RtnPartMst/RtnPartMst.vue';

import moment from 'moment';

export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			pprNo: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},

	async created() {
		this.$sf_toggleLoading(true);
		this.getPwaAppr_()
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
			})
			.finally(() => {
				this.$sf_toggleLoading(false);
			});
	},
	computed: {
		...rootComputed,
		...serviceComputed,
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getPwaAppr_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async onGoPwaApcn(argsCnt, argsState) {
			//오늘로부터 30일 전
			const StartDt = moment().subtract(30, 'd').format('YYYYMMDD');
			//오늘
			const EndDt = moment().format('YYYYMMDD');
			const LongEndDt = moment().subtract(3, 'd').format('YYYYMMDD');
			//건수, 상태코드
			//건수가 있는것만 링크를 건다
			if (argsCnt > 0) {
				const name = this.getMessage_('QWCC000949'); //PWA 신청현황
				let item = {
					name,
					component: PwaApcn, //import할 컴포넌트 이름
					scrId: this.pwaApcnScrId, //이동할 scr
					msgKey: 'QWCC000949' //PWA 신청현황
				};

				let pStartDt = '';
				let pEndDt = '';
				let pState1 = argsState;
				let pState2 = '';
				let pState3 = '';

				if (pState1 == 'A') {
					//승인
					pState1 = '10'; //승인
					pState2 = '';
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'G') {
					//기각
					pState1 = '20'; //기각
					pState2 = '';
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'R') {
					//반려
					pState1 = '30'; //반려
					pState2 = '';
					pState3 = '20'; //날짜구분(확정일)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'O') {
					//미결
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = moment().subtract(3, 'd').format('YYYYMMDD');
					pEndDt = EndDt;
				} else if (pState1 == 'W') {
					//작성중
					pState1 = '';
					pState2 = '10'; //작성중일경우(작성중)
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'C') {
					//처리완료
					pState1 = '';
					pState2 = '30'; //처리완료 (확정)
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'LO') {
					//장기미결
					pState1 = '';
					pState2 = '20'; //장기미결 3일이상 처리완료 (확정)
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = moment(LongEndDt).subtract(5, 'y').format('YYYYMMDD');
					pEndDt = LongEndDt;
				} else if (pState1 == '1ML') {
					//30일이내
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10';
					pStartDt = moment().subtract(30, 'd').format('YYYYMMDD');
					pEndDt = moment().format('YYYYMMDD');
				} else if (pState1 == '3ML') {
					//30~90일이내
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10';
					pStartDt = moment().subtract(90, 'd').format('YYYYMMDD');
					pEndDt = moment().subtract(31, 'd').format('YYYYMMDD');
				} else if (pState1 == '3MG') {
					//90일이상
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10';
					pStartDt = moment().subtract(5, 'y').format('YYYYMMDD');
					pEndDt = moment().subtract(91, 'd').format('YYYYMMDD'); //오늘날짜로부터 3개월 이전날짜를 셋팅함. pwa3개월 이상인 것들만 조회함.
				} else {
					pState1 = '';
					pState2 = ''; //미결일경우(신청)
					pState3 = '10';
					pStartDt = StartDt;
					pEndDt = EndDt; //오늘날짜로부터 3개월 이전날짜를 셋팅함. pwa3개월 이상인 것들만 조회함.
				}

				//console.log('pState1>>>>>', pState1);
				//console.log('pState2>>>>>', pState2);
				//console.log('pState3>>>>>', pState3);
				//console.log('pStartDt>>>>', pStartDt);
				//console.log('pEndDt>>>>>>', pEndDt);

				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, pStartDt, pEndDt, pState1, pState2, pState3 });
			}
		},
		async onGoClaimClick(argsCnt, argsState) {
			//오늘로부터 30일 전
			const StartDt = moment().subtract(30, 'd').format('YYYYMMDD');
			const EndDt = moment().format('YYYYMMDD');

			if (argsCnt > 0) {
				const name = this.getMessage_('QWCC001865'); //클레임 현황
				let item = {
					name,
					component: ClamRepay, //import할 컴포넌트 이름
					scrId: this.clamRepayScrId, //this.pwaApcnScrId, //이동할 scr
					msgKey: 'QWCC001865' //클레임 현황
				};

				let pStartDt = '';
				let pEndDt = '';
				let pState1 = argsState; //처리결과
				let pState2 = ''; //처리단계
				let pState3 = ''; //날짜구분

				if (pState1 == 'A') {
					//승인
					pState1 = '10'; //승인
					pState2 = '';
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else {
					pState1 = '';
					pState2 = ''; //미결일경우(신청)
					pState3 = '10'; //날짜구분(신청일)
					pStartDt = StartDt;
					pEndDt = EndDt; //오늘날짜로부터 3개월 이전날짜를 셋팅함. pwa3개월 이상인 것들만 조회함.
				}

				//console.log('pState1>>>>>', pState1);
				//console.log('pState2>>>>>', pState2);
				//console.log('pState3>>>>>', pState3);
				//console.log('pStartDt>>>>', pStartDt);
				//console.log('pEndDt>>>>>>', pEndDt);
				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, pStartDt, pEndDt, pState1, pState2, pState3 });
			}
		},
		async onGoRtnPartMstClick(argsCnt, argsState) {
			//오늘로부터 30일 전
			const StartDt = moment().subtract(30, 'd').format('YYYYMMDD');
			const EndDt = moment().format('YYYYMMDD');

			if (argsCnt > 0) {
				const name = this.getMessage_('QWCC001212'); 
				let item = {
					name,
					component: RtnPartMst, //import할 컴포넌트 이름
					scrId: this.rtnPartMstScrId, //this.pwaApcnScrId, //이동할 scr
					msgKey: 'QWCC001212' 
				};

				let pStartDt = '';
				let pEndDt = '';
				let pState1 = argsState; 
				let pState2 = ''; 
				let pState3 = ''; 

				if (pState1 == 'A') {
					//승인
					pState1 = '10'; 
					pState2 = '';
					pState3 = '10'; 
					pStartDt = moment().subtract(365, 'd').format('YYYYMMDD');
					pEndDt = EndDt;
				} else if (pState1 == 'R') {
					//승인
					pState1 = '20'; 
					pState2 = '';
					pState3 = '10'; 
					pStartDt = moment().subtract(365, 'd').format('YYYYMMDD');
					pEndDt = EndDt;
				} else {
					pState1 = '99';
					pState2 = ''; 
					pState3 = '10'; 
					pStartDt = moment().subtract(365, 'd').format('YYYYMMDD');
					pEndDt = EndDt; 
				}

				//console.log('pState1>>>>>', pState1);
				//console.log('pState2>>>>>', pState2);
				//console.log('pState3>>>>>', pState3);
				//console.log('pStartDt>>>>', pStartDt);
				//console.log('pEndDt>>>>>>', pEndDt);
				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, pStartDt, pEndDt, pState1, pState2, pState3 });
			}
		},
		async onGoRoClick(argsCnt, argsState) {
			const LongEndDt = moment().subtract(8, 'd').format('YYYYMMDD');
			const OStartDt = moment().subtract(7, 'd').format('YYYYMMDD');
			const StartDt = moment().subtract(30, 'd').format('YYYYMMDD');
			const EndDt = moment().format('YYYYMMDD');
			//const today = moment().format('YYYYMMDD');

			let item = {
				name: this.getMessage_('QWCC001171'), //RO신청현황
				component: RoApcn, //import할 컴포넌트 이름
				scrId: this.roApcnListScrId, //이동할 scr
				msgKey: 'O30000004' //RO신청현황
			};

			let pStartDt = '';
			let pEndDt = '';
			let pState1 = argsState; //처리결과
			let pState2 = ''; //처리단계
			let pState3 = ''; //날짜구분
			let pState4 = ''; //정비유형
			let pState5 = ''; //고품회수상태
			if (argsCnt > 0) {
				if (pState1 == 'R') {
					//반려
					pState1 = '30'; //반려
					pState3 = '20'; //날짜구분(확정일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'O') {
					//미결
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = OStartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'G') {
					pState1 = '20'; //기각
					pState3 = '10'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'W') {
					//작성중
					pState1 = '';
					pState2 = '10'; //작성중일경우(작성중)
					pState3 = '10'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'C') {
					//처리완료
					pState1 = '';
					pState2 = '30'; //처리완료 (확정)
					pState3 = '10'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = StartDt;
					pEndDt = EndDt;
				} else if (pState1 == 'NA') {
					//처리완료
					pState1 = '10';
					pState2 = '30'; //처리완료 (확정)
					pState3 = '20'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pState5 = '05'
					pStartDt = moment().subtract(365, 'd').format('YYYYMMDD');
					pEndDt = EndDt;
				} else if (pState1 == 'LO') {
					//장기미결
					pState1 = '';
					pState2 = '20'; //장기미결 7일이상 처리완료 (확정)
					pState3 = '10'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = moment(LongEndDt).subtract(5, 'y').format('YYYYMMDD');
					pEndDt = LongEndDt;
				} else if (pState1 == '1ML') {
					//클레임 처리대기 현황(30일이내)
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10';
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = moment().subtract(30, 'd').format('YYYYMMDD');
					pEndDt = moment().format('YYYYMMDD');
				} else if (pState1 == '3ML') {
					//클레임 처리대기 현황(30~90일이내)
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10';
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = moment().subtract(90, 'd').format('YYYYMMDD');
					pEndDt = moment().subtract(31, 'd').format('YYYYMMDD');
				} else if (pState1 == '3MG') {
					//클레임 처리대기 현황(90일이상)
					pState1 = '';
					pState2 = '20'; //미결일경우(신청)
					pState3 = '10';
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = moment().subtract(5, 'y').format('YYYYMMDD');
					pEndDt = moment().subtract(91, 'd').format('YYYYMMDD'); //오늘날짜로부터 3개월 이전날짜를 셋팅함. 클레임 3개월 이상인 것들만 조회함.
				} else {
					//전체
					pState3 = '10'; //날짜구분(신청일)
					pState4 = '10'; //정비유형(10.보증수리)
					pStartDt = StartDt;
					pEndDt = EndDt;
				}
				//console.log('pState4', pState4);

				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, pStartDt, pEndDt, pState1, pState2, pState3, pState4, pState5 });
			}
		}
	}
};
</script>
